import Vue from 'vue'
import Router from 'vue-router'
import VueResource from 'vue-resource'
import Hello from '@/components/Hello'
import Vote from '@/components/Vote'
import IndexTop10 from '@/components/IndexTop10'
import Expert from '@/components/Expert'
import Man from '@/components/Man'
import Asiatop10 from '@/components/Asiatop10'
import Popular from '@/components/Popular'

const VueScrollTo = require('vue-scrollto')
Vue.use(VueScrollTo)
Vue.use(Router)
// Vue.use(VueResource)

export default new Router({
  // mode: 'history',
  base: '/2017/beautyawards/',
  routes: [
    {
      path: '/home',
      name: 'Hello',
      component: Hello
    },
    {
      path: '/vote/:id',
      name: 'Vote',
      component: Vote,
      // props: true
    },
    {
      path: '/Top10',
      name: 'IndexTop10',
      component: IndexTop10,
      // props: true
    },
    {
      path: '/Expert',
      name: 'Expert',
      component: Expert,
      // props: true
    },
    {
      path: '/Man',
      name: 'Mam',
      component: Man
    },
    {
      path: '/Asiatop10',
      name: 'Asiatop10',
      component: Asiatop10
    },
    {
      path: '/Popular/:id',
      name: 'Popular',
      component: Popular
    }
  ]
})





// WEBPACK FOOTER //
// ./src/router/index.js